import { type UserHistory, type UserId } from '@terros/common'

/** A stretch of time; `end` is exclusive and `Infinity` while it's still going */
export type TimeWindow = {
  start: number
  end: number
}

type GetOwnershipWindowsProps = {
  ownerHistory: UserHistory | undefined
  userId: UserId | undefined
}

/** Every stretch `userId` owned the account: from their assignment until someone else took it over */
export const getOwnershipWindows = ({ ownerHistory = [], userId }: GetOwnershipWindowsProps): TimeWindow[] => {
  const sorted = [...ownerHistory].sort((a, b) => a.timestamp - b.timestamp)
  return sorted.flatMap((item, index) => {
    const continuesRun = sorted[index - 1]?.userId === userId
    if (item.userId !== userId || continuesRun) return []
    const handedOver = sorted.slice(index + 1).find((next) => next.userId !== userId)
    return [{ start: item.timestamp, end: handedOver?.timestamp ?? Infinity }]
  })
}

export const isInWindows = ({ timestamp, windows }: { timestamp: number; windows: TimeWindow[] }): boolean =>
  windows.some(({ start, end }) => timestamp >= start && timestamp < end)
